import React from "react";
import cx from "classnames";
import { Skeleton } from "components/Skeleton";

import * as styles from "./MatchPageSkeleton.module.scss";

const MatchPageSkeleton = ({
  withMargin = false,
}: { withMargin?: boolean }) => {
  return (
    <div className={cx(styles.page, { [styles.withMargin]: withMargin })}>
      <div className={styles.titleBlock}>
        <Skeleton shape="circle" className={styles.titleIcon} />
        <Skeleton className={styles.title} mode="light" />
      </div>
      <ScoreboardSkeleton />
    </div>
  );
};

const ScoreboardSkeleton = () => {
  return (
    <div className={styles.competitors}>
      <div className={styles.competitor}>
        <Skeleton shape="circle" className={styles.competitorIcon} />
        <Skeleton className={styles.competitorName} mode="light" />
        <span className={styles.separator}>@</span>
      </div>
      <div className={styles.competitor}>
        <Skeleton shape="circle" className={styles.competitorIcon} />
        <Skeleton className={styles.competitorName} mode="light" />
      </div>
      <Skeleton className={styles.counter} />
    </div>
  );
};

export { MatchPageSkeleton, ScoreboardSkeleton };
